import { trackPromise } from 'react-promise-tracker';

import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import api from './api';
import Axios, { AxiosResponse } from 'axios';
import { PerguntaQuestionarioMinuta } from './minuta/QuestionarioMinuta';
import { clickDownloadElement } from '@app/helpers/download';
import { DemandaComRequisicao } from './requisitanteCapex';
import { PaginationResult } from './pagination';
import { toEndOfDayISOString, toStartOfDayISOString } from '@app/helpers/dateTimeFormats';
import { notification, OptionProps } from '@digital/ui';

export const enum TipoDemanda {  
  'Aditivo Faturamento Direto' = 5,
  'Faturamento Direto' = 4,
  'Acordo de Fornecimento' = 3,
  'Aditivo' = 2,
  'Nova Contratação' = 1,
}
export const optionsTipo = [
  { text: 'Nova Contratação', value: 1 },
  { text: 'Aditivo', value: 2 },
  { text: 'Acordo de Fornecimento', value: 3 },
  { text: 'Faturamento Direto', value: 4 },
  { text: 'Aditivo Faturamento Direto', value: 5 },
];

export interface Demanda {
  gestorTecnicoId?: string;
  id: string;
  requisicaoCompraId?: string;
  ordemCompraId?: string;
  governancaAprovacaoId?: string;
  identificador: number;
  identificadorTexto: string;
  anexosDemanda: AnexoDemanda[];
  tipo: number;
  diretoriaId: string;
  areaId: string;
  departamentoId: string;
  tipoServicoId: string;
  status?: string;
  statusCodigo?: number;
  step: number;
  capex: boolean;
  opex: boolean;
  contaResultado?: boolean;
  isEmergencial?: boolean;
  descOrdemInvestimento?: string;
  justificativaCancelamento?: string;
  codCentroDeCusto?: string;
  centroDeCusto?: string;
  demandante?: string;
  demandanteId?: string;
  justificativaDevolucao?: string;
  requisicaoAbertaPeloDepPlanejamentoControle?: boolean;
  contratoId?: string;
  requisitanteId?: string;
  necessitaEspecificacao?: boolean;
  comEspecificacao: boolean;
  comEspecificacaoSwitch: boolean;
  semEspecificaoSwitch: boolean;
  reaberturaRequisicaoCompra?: boolean;
  isModificando?: boolean;
  demandaAprovadaNoTotvs?: boolean;
  perguntasQuestionarioMinuta?: PerguntaQuestionarioMinuta[];
  createdBy?: string;
  administradorContratoId?: string;
  expectativaValorFinal: number; // Valor colocado pelo usuário
  valorAditivo?: number;
  novoValorFinal?: number; // expectativaValorFinal +  valorAditivo

  statusDemandaTexto: string;
  responsavelGpc: string;
  responsavelGpcId: string;
  compradorId: string;
  valorPrevistoAnoExecucao: string;
  objeto: string;
  haveraMaoDeObraEmPTR: boolean;
  haveraSla: boolean;
  haveraDespesasReembolsaveis: boolean;
  statusDemanda: StatusDemanda;
  statusDemandaCodigo: number;
  anexoDemandaAnaliseRiscoPrivacidade: AnexoDemandaAnaliseRiscoPrivacidade[];
  requisicaoCompra: any;
  isPrazo?: boolean;

  comprador?: string;
  contrato?: string;
  contratoOuPedido?: string;
  ddi?: string;
  expectativaDePrazo?: string;
  isFornecedorDirecionado?: boolean;
  isValor?: boolean;
  isVisitaTecnica?: string;
  justificativa?: string;
  ordemCompra?: string;
  requisitante?: string;
  resultadoAnaliseRiscoPrivacidade?: string;
  statusGovernancaAprovacao?: string;
  eligibilidadeGovernancaAprovacao?: string;
  temPrevisaoOrcamentaria?: string;
  tipoContrato?: string;
  numeroContratoPcs?: string;
  tipoDespesa?: string;
  tipoServico?: string;
  tipoTexto?: string;
  diretoria?: string;
  area?: string;
  departamento?: string;
  criterioValorDDI?: string;
  criterioPrazoDDI?: string;
  criterioValorGovernanca?: string;
  categoriaDDI?: string;
  alocacaoDeCusto?: string;
  dataAbertura?: string;
  tipoAditivo?: string;
  resultadoCCI?: string;
  rotaAprovacao?: string;

  ordemInvestimento?: string;
  codOrdemInvestimento?: string;
  codLotacaoDestino?: string;
  lotacaoDestino?: string;
  ordemManutencao?: string;
  codItemServico?: string;
  numeroContrato?: string;
  numeroPedido?: string;
  isClausula?: boolean;
  isValorSemAcrescimoEscopo?: boolean;
  isValorComAcrescimoEscopo?: boolean;
  isRemanejamentoVerbasEntreLinhas?: boolean;
  isAcrescimoEscopoRemanejamentoVerba?: boolean;
  projeto?: string;
  pacote?: string;

  expectativaDePrazoConfirmacao: any;
  haveraMaoDeObraEmPTRConfirmacao: any;
  haveraSlaConfirmacao: any;
  haveraDespesasReembolsaveisConfirmacao: any;
  novoPrazo?: string;
  novoPrazoConfirmacao: any;
  isVisitaTecnicaConfirmacao: any;

  forceStep?: boolean;
  isDemandante?: boolean;
  caracteristicaContratacao?: string;
  relacionamentoEntidadePublica?: boolean;
  necessitaRevalidacaoEconomica?: boolean;

  tipoReavaliacao?: number;
  valorMenorProposta?: number;
  valorContratacaoNovaRC?: number;
  alterarDocumentacao?: boolean;

  dadosHistorico?: DemandaDadosHistorico;


  valorPedido ?: number;
  vigencia ?: number;
  valorTotalContrato ?: number;
  condicaoPagamento ?: string;
  maoDeObraTrombetas ?: boolean;
  tipoFaturamento ?: number;
  itemCodigoContrato ?: string;
  ordemInvestimentoGuardaChuva ?: string;
  ordemCompraGuardaChuva ?: string;
  contratoGuardaChuva ?: string;

  identificadorPQ?: string;

  usuarioAjuste?: string;
  dataAjuste?: string;
  justificativaAjusteOrcamentario?: string;
  prazoAtual?: string;
  dataTermino?: string;
}

export interface StatusDemanda {
  id: string;
  nome: string;
  codigo: number;
}

export interface AnexoDemanda {
  id: string;
  descricaoDocumento: string;
  obrigatorio: boolean;
  automatico: boolean;
  demandaId: string;
  arquivoAtual?: AnexoDemanda;
  exibir?: boolean;
  historicoComentariosAnexoDemanda?: Comentario[];
  contemComentarios?: boolean;
}

export interface AnexoDemandaAnaliseRiscoPrivacidade {
  id: string;
  descricaoDocumento: string;
  demandaId: string;
  temResultado: boolean;
  resultado: string;
}

export interface Comentario {
  id: string;
  mensagem: string;
  mrn: boolean;
  nomeDoUsuario: string;
  dataHoraInclusao: string;
}

export interface ArquivoAnexoDemanda {
  id: string;
  nome: string;
  extensao: string;
  local: string;
}

export interface AbaDadosGerais {
  id: string;
  tipo?: number;
  identificador: number;
  identificadorTexto: string;
  statusDemandaTexto: string;
  responsavelGpc: string;
  responsavelGpcId: string;
  compradorId: string;
  valorPrevistoAnoExecucao: string;
  objeto: string;
  haveraMaoDeObraEmPTR: boolean;
  haveraSla: boolean;
  haveraDespesasReembolsaveis: boolean;
  statusDemanda: StatusDemanda;
  statusDemandaCodigo: number;
  anexosDemanda: AnexoDemanda[];
  anexoDemandaAnaliseRiscoPrivacidade: AnexoDemandaAnaliseRiscoPrivacidade[];
  requisicaoCompra: any;
  isPrazo?: boolean;
  validarDemanda?: boolean;
}

export interface DadosAbaSumario {
  id: string;
  identificadorTexto: string;
  statusDemandaTexto: string;
  comprador?: string;
  contrato?: string;
  contratoOuPedido?: string;
  ddi?: string;
  demandante?: string;
  expectativaDePrazo?: string;
  expectativaValorFinal?: string;
  haveraDespesasReembolsaveis?: string;
  haveraMaoDeObraEmPTR?: string;
  vigencia?: number;
  haveraSla?: string;
  isEmergencial?: string;
  isFornecedorDirecionado?: string;
  isValor?: boolean;
  isVisitaTecnica?: string;
  justificativa?: string;
  novoValorFinal?: string;
  valorPedido?: string;
  objeto?: string;
  ordemCompra?: string;
  requisicaoCompra?: string;
  requisitante?: string;
  resultadoAnaliseRiscoPrivacidade?: string;
  statusGovernancaAprovacao?: string;
  eligibilidadeGovernancaAprovacao?: string;
  temPrevisaoOrcamentaria?: string;
  tipo?: string;
  tipoContrato?: string;
  contratoGuardaChuva?: string;
  fornecedorContratoOriginal?: string;
  numeroContratoPcs?: string;
  tipoDespesa?: string;
  tipoServico?: string;
  tipoTexto?: string;
  valorAditivo?: string;
  valorAtual?: string;
  diretoria?: string;
  area?: string;
  departamento?: string;
  criterioValorDDI?: string;
  criterioPrazoDDI?: string;
  criterioValorGovernanca?: string;
  categoriaDDI?: string;
  alocacaoDeCusto?: string;
  dataAbertura?: string;
  tipoAditivo?: string;
  resultadoCCI?: string;
  rotaAprovacao?: string;
  gestorTecnico?: string;
  categoriaServico?: string;
  relacionamentoEntidadePublica?: string;
  prazoAditivo?: Date;
  dataCriacaoRc?: Date;
  aprovacaoOc?: Date;
  validarDemanda?: boolean;
  nomeFornecedor?: string;
}

export interface DeleteAnexo {
  id: string;
  obrigatorio: boolean;
}

export interface HistoricoDemanda {
  id: string;
  demandaId: string;
  usuarioResponsavel?: string;
  statusAnterior?: string;
  statusNovo?: string;
  descricao?: string;
  dataHoraFormatada: string;
}

export interface DemandaFiltro {
  tipoServicoId: string;
  descricaoDocumento: string;
  tag: string;
}

export interface DescricaoDocumento {
  id: string;
  value: string;
}

export interface OrdemInvestimentoSge {
  numero?: string;
  id?: string;
  nome?: string;
  codigoPacote?: string;
}

export interface CentroCusto {
  id?: string;
  codigo?: string;
  descricao?: string;
}

export interface ExpectativaPrazo {
  expectativaConclusao: Date;
  stepsConclusao: StepConclusao[];
}

export interface StepConclusao {
  titulo: string;
  data: Date;
}

export interface DemandaDadosHistorico {
  objeto?: string;
  ordemInvestimento?: string;
  codOrdemInvestimento?: string;
  valorContratacaoDemanda?: number;
  expectativaDePrazo?: string;
  capex?: boolean;
  opex?: boolean;
  contaResultado?: boolean;
  itemServico?: string;
  codItemServico?: string;
  codCentroDeCusto?: string;
  centroDeCusto?: string;
  temPrevisaoOrcamentaria?: boolean;
  projeto?: string;
  pacote?: string;
  ordemManutencao?: string;
  requisicaoAbertaPeloDepPlanejamentoControle?: boolean;
  valorAtual?: number;
  valorAditivo?: number;
  novoValorFinal?: number;
}
export interface ItemsContrato {
  total: number;
  itens: ItemContrato[];
}
export interface ItemContrato {
  numeroContrato: number;
  descricaoItem: string;
  codigoItem: string;
  ordemCompra: string;
  ordemInvestimento: string;
  numItemSequence: string;
}

export interface PcsInfo {
  prazoDataFinal: string; // ISO date string
  prazoDataInicio: string; // ISO date string
  numeroPcs: number;
  numeroContrato: number;
  nomeFornecedor: string;
  numeroFornecedor: string;
  descricaoEscopo: string;
  valorPcs: number;
  codigoEstabelecimento: string;
  departamento: string;
  area: string;
  diretoria: string;
  areaId: string;
  diretoriaId: string;
  departamentoId: string;
  cnpjFornecedor: string;
  razaoSocialFornecedor: string;
  emailFornecedor: string;
  telefoneFornecedor: string;
  nomeContatoFornecedor: string;
  notifications: any[]; // pode tipar melhor se souber o formato
  invalid: boolean;
  valid: boolean;
}

export const createDemanda = (demanda: Demanda) => {
  return api.post<any>('demandas/Create', demanda);
};
export const updateAnexoDemandaExibir = (id: string) => api.put(`anexoDemanda/UpdateAnexoDemandaExibir/${id}`);
export const aprovarDemanda = (id: string) => api.put(`demandas/aprovar/${id}`);
export const devolverDemanda = (values: { id: string; justificativa: string; }) => api.post(`demandas/devolver`, values);
export const devolverDemandaGestorTecnico = (values: { id: string; justificativa: string; }) =>
  api.post(`demandas/devolverGestorTecnico`, values);
export const validarDemandaGestorTecnico = (id: string) => api.put(`demandas/validarDemandaGestorTecnico/${id}`);
export const cancelarDemanda = (id: string, demanda: Demanda) => api.put(`demandas/cancelar/${id}`, demanda);
export const cancelarDemandaJustificativa = (id: string, justificativa: string) => api.put(`demandas/cancelar/${id}`, {
    justificativaCancelamento: justificativa
  });

export const cancelarOCDemanda = (id: string, justificativa: string) => api.post(`demandas/${id}/cancelarOc`, { justificativa });

export const modificarDemanda = (demandaId: string, isRCNaOc = false) =>
  api.post(`demandas/modificar`, { demandaId, isRCNaOc });
export const pausarDemanda = (id: string) => api.put(`demandas/pausar/${id}`);
export const retomarDemanda = (id: string) => api.put(`demandas/retomar/${id}`);
export const assumirDemanda = (id: string) => api.put(`demandas/assumir/${id}`);
export const updateDemanda = (demanda: Demanda) => api.put<any>(`demandas/${demanda.id}`, demanda);
export const EnviarDemanda = (demanda: any) => api.put<any>(`demandas/EnviarDemanda`, demanda);
export const enviarModificacaoDemanda = (demandaId: string) =>
  api.post(`demandas/EnviarModificacaoDemanda`, { demandaId }, { disableNotification: true });
export const desistirModificacaoDemanda = (demandaId: string) =>
  api.post<any>(`demandas/DesistirModificacaoDemanda`, { demandaId }, { disableNotification: true });
export const getAllDemandas = () => api.get<Demanda[]>('demandas');
export const getAllDemandasComFiltro = (filtro: DemandaFiltro) =>
  api.post('demandas/GetAllComFiltro', filtro, { disableNotification: true });
export const getDadosGerais = (id: string) => api.get<AbaDadosGerais>(`demandas/GetDadosGerais/${id}`);
export const getSumario = (id: string, ocId?: string) => api.get<AbaSumario>(`demandas/${id}/GetSumario/${ocId}`);
export const getDemanda = (id: string) => api.get<Demanda>(`demandas/GetDemanda/${id}`);
//export const getDemandasDemandanteAndamento = () => api.get<PaginationResult<Demanda>>(`demandas/GetDemandasDemandanteAndamento`);

export interface FiltroDemanda {
  PreSuprimentos: boolean;
  ConcluidoCancelado: boolean;
  PeriodoInicio?: Date| null;
  PeriodoFim?: Date| null;
}

export const getAllDemandantes = () => {
  return api.get<OptionProps[]>(`demandas/getAllDemandantes`);
};

export const getAllRequisitantes = () => {
  return api.get<OptionProps[]>(`demandas/getAllRequisitantes`);
};
export const updateDemandanteDemanda = (value: any) => api.put('demandas/UpdateDemandante', value);
export const updateRequisitanteDemanda = (value: any) => api.put('demandas/UpdateRequisitante', value);



// Usado pela listagem e pela exportação, para que o Excel saia igual ao que está na tela
export const montarParamsDemanda = (
  filtroBase: FiltroDemanda,
  filters?: Record<string, (string | number)[] | null>,
  sorter?: any
) => {
  const params = new URLSearchParams();

  // Filtros fixos
  params.append('PreSuprimentos', String(filtroBase.PreSuprimentos));
  params.append('ConcluidoCancelado', String(filtroBase.ConcluidoCancelado));
  if (filtroBase.PeriodoInicio && filtroBase.PeriodoFim) {
    params.append('PeriodoInicio', toStartOfDayISOString(filtroBase.PeriodoInicio));
    params.append('PeriodoFim', toEndOfDayISOString(filtroBase.PeriodoFim));
  }

  // Filtros dinâmicos
  Object.entries(filters || {}).forEach(([key, values]) => {
    if (values) {
      values.forEach(value => params.append(key, String(value)));
    }
  });

  // Ordenação
  if (sorter && sorter.field && sorter.order) {
    params.append('ordenarPor', sorter.field);
    params.append('ordem', sorter.order === 'ascend' ? 'ASC' : 'DESC');
  }

  return params;
};

export const getDemandasDemandante = (
  filtroBase: FiltroDemanda,
  page: number,
  size: number,
  filters?: Record<string, (string | number)[] | null>,
  sorter?: any
) => {
  const params = montarParamsDemanda(filtroBase, filters, sorter);

  // Paginação
  params.append('page', String(page));
  params.append('size', String(size));

  // GET
  return api.get<PaginationResult<Demanda>>(
    `demandas/GetDemandasDemandanteAndamento?${params.toString()}`,
    {},
    //{ disableNotification: true }
  );
};


// Erro chega como blob (JSON/texto), porque a requisicao usa responseType 'blob' e nao o wrapper api
const mensagemDeErroDoBlob = async (data: any) => {
  const padrao = 'Houve um erro ao exportar as demandas.';
  try {
    if (!data || typeof data.text !== 'function') return padrao;
    const texto = await data.text();
    if (!texto) return padrao;
    try {
      const json = JSON.parse(texto);
      return json.title || json.message || texto;
    } catch {
      return texto;
    }
  } catch {
    return padrao;
  }
};

const baixarExportacaoDemanda = async (rota: string, nomeArquivo: string, params: URLSearchParams) => {
  let resp;
  try {
    resp = await Axios.get(`/api/demandas/ExportarExcel/${rota}?${params.toString()}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    });
  } catch (erro: any) {
    notification.error(await mensagemDeErroDoBlob(erro && erro.response && erro.response.data));
    return;
  }

  const now = new Date();
  const timestamp = `${now.getFullYear()}${(now.getMonth() + 1)
    .toString()
    .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now
    .getHours()
    .toString()
    .padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now
    .getSeconds()
    .toString()
    .padStart(2, '0')}`;

  const url = window.URL.createObjectURL(new Blob([resp.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${nomeArquivo}_${timestamp}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const ExportarDemandaAndamento = async (
  filtroBase: FiltroDemanda,
  filters?: Record<string, (string | number)[] | null>,
  sorter?: any
) =>
  baixarExportacaoDemanda(
    'Andamento',
    'exportacao_demanda_andamento',
    montarParamsDemanda({ ...filtroBase, ConcluidoCancelado: false }, filters, sorter),
  );

export const ExportarDemandaConcluido = async (
  filtroBase: FiltroDemanda,
  filters?: Record<string, (string | number)[] | null>,
  sorter?: any
) =>
  baixarExportacaoDemanda(
    'Concluido',
    'exportacao_demanda_concluido',
    montarParamsDemanda({ ...filtroBase, ConcluidoCancelado: true }, filters, sorter),
  );

export const getDemandasPreSuprimentosAndamento = () =>
  api.get<Demanda[]>(`demandas/GetDemandasPreSuprimentosAndamento`);
export const getDemandasDemandanteConcluido = (filtro: any) =>
  api.post<Demanda>(`demandas/GetDemandasDemandanteConcluido`, filtro, { disableNotification: true });
export const getDemandasPreSuprimentosConcluido = (filtro: any) =>
  api.post<Demanda>(`demandas/GetDemandasPreSuprimentosConcluido`, filtro, { disableNotification: true });

export const getAnexosDemanda = (values: any) =>
  api.post<AnexoDemanda[]>(`demandas/GetAnexoDemanda`, values, { disableNotification: true });

export const getAnexoFormularioReqCompraApi = (demandaId: string) =>
  api.get<AnexoDemanda[]>(`anexoDemanda/GetAnexoFormularioReqCompra/${demandaId}`);
export const updateTags = (value: any) => api.put('demandas/UpdateTags', value);
export const updateInformacoesComplementares = (value: any) =>
  api.put('demandas/UpdateInformacoesComplementares', value);
export const updateComprador = (values: any) => api.put('demandas/UpdateComprador', values);
export const updateCaracteristicaContratacao = (values: any) => api.put('demandas/UpdateCaracteristica', values);
export const uploadArquivoAnexoDemanda = (value: any) => api.put('anexoDemanda/Upload', value);
export const excluirAnexo = (id: string) => api.delete(`demandas/DeleteAnexo/${id}`);
export const getHistoricoDemanda = (id: string) => api.get<HistoricoDemanda[]>(`demandas/GetHistoricoDemanda/${id}`);
export const getDescricoesDocumento = () => api.get<DescricaoDocumento[]>('anexoDemanda/descricoesDocumento');
export const updateAnexoAprovacao = (values: any) => api.put('anexoDemanda/UpdateAprovacao', values);
export const updateAnexoFormularioReqCompraAprovacao = (values: any) =>
  api.put('anexoDemanda/UpdateAnexoFormularioReqCompraAprovacao', values);
export const updateAnexoAnaliseRiscoPrivacidadeResultado = (values: any) =>
  api.put('anexoDemanda/UpdateAnexoAnaliseRiscoPrivacidadeResultado', values);
export const getDescricoesDocumentoOptions = () =>
  getDescricoesDocumento().then(descricaoDocumento =>
    (descricaoDocumento || []).map(item => ({ text: item.value, value: item.value })),
  );
export const getCalcularExpectativaConclusao = (values: any) =>
  api.post<ExpectativaPrazo>(`demandas/GetCalcularExpectativaConclusao`, values, { disableNotification: true });

export const updateDDIManualCommand = (values: any) =>
  api.post<any>(`demandas/UpdateDDIManualCommand`, values);

export const FinalizarEtapaDadosQuestionario = (values: any) =>
  api.put(`demandas/FinalizarEtapaDadosQuestionario`, values);
export const updateTipoServicoDemanda = (data: any) => api.post(`demandas/updateTipoServicoDemanda`, data);

export const substituirAnexo = (values: any) => {
  const form = new FormData();
  form.append('id', values.id);
  form.append('arquivo', values.arquivo);
  form.append('justificativa', values.justificativa);
  return api.put('demandas/SubstituirArquivo', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const createAnexoDemanda = (values: any) => {
  const form = new FormData();
  Object.keys(values).forEach(key => {
    form.append(key, values[key]);
  });
  return api.post<any>('anexoDemanda/Create', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const viewAnexoDemanda = async (id: string, nome: string) => {
  const url = window.location.origin + `/api/anexoDemanda/DownloadArquivo/${id}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nome);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) window.open(fileUrl);
  });
};

export const downloadAnexoDemanda = (id: string, nome: string) => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/anexoDemanda/DownloadArquivo/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', 'downloadArquivo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivo').outerHTML = '';
    }),
  );
};
export const excluiAnexo = (anexo: DeleteAnexo) => api.put<any>(`anexoDemanda/ExcluiAnexo`, anexo);

export const baixarTudoDadosGerais = id => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/demandas/DownloadTudoDadosGerais/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'anexos.zip');
      link.setAttribute('id', 'downloadArquivo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivo').outerHTML = '';
    }),
  );
};

export const validaCentroCusto = (codigo: string) => api.get<CentroCusto>(`demandas/GetCentroCusto/${codigo}`);
export const validaOiSge = (codigo: string) => api.get<OrdemInvestimentoSge>(`demandas/GetOi/${codigo}`);
export const verificarValorMinimoGpc = (id: string) => api.get<boolean>(`demandas/verificaValorMinimoGpc/${id}`);
export const salvarComentarioCampo = (form: any) => api.post(`demandas/salvarComentarioCampo`, form);
export const salvarComentarioAnexo = (form: any) => api.post(`anexoDemanda/salvarComentario`, form);
export const salvarComentarioAnexoFormularioReqCompra = (form: any) =>
  api.post(`anexoDemanda/SaveComentarioAnexoFormularioReqCompra`, form);
export const obterComentarioCampoDemanda = (campoId: string, demandaId: string) =>
  api.get(`demandas/${demandaId}/comentarios/${campoId}`);
export const obterComentarioAnexoDemanda = (id: string) => api.get(`anexoDemanda/getComentarios/${id}`);
export const obterAnexosReaberturaRequisicao = (id: string) =>
  api.get<AnexoDemanda[]>(`anexoDemanda/GetAnexosReaberturaRequisicao/${id}`);
export const obterComentarioAnexoFormularioReqCompra = (id: string) =>
  api.get(`anexoDemanda/getComentariosAnexoFormularioReqCompra/${id}`);
export const getPcsDemandaInfo = (numero: string) =>
  api.post<PcsInfo>(`demandas/GetPcs/${numero}`, {}, { disableNotification: 'true' });
export const getSumarioExecutivo = (id: string) => api.get<SumarioExecutivo>(`demandas/GetSumarioExecutivo/${id}`);
export const updateSumarioExecutivo = (values: any, widget: string) =>
  api.post<SumarioExecutivo>(`demandas/UpdateSumarioExecutivo`, { ...values, widget });

export const obterDadosAprovacaoTotvs = (id: string) => api.get(`demandas/GetDadosAprovacaoTotvs/${id}`);

export const getItemsContrato = (numero: string) =>
  api.get<ItemsContrato>(`demandas/GetItemsContrato/${numero}`, {}, { disableNotification: 'true' });

export const getOrdemCompraPorNumeroContrato = (numeroContrato: number) =>
  api.get<{ contratoGuardaChuva: number | null }>(`demandas/GetOrdemCompraPorNumeroContrato/${numeroContrato}`, {}, { disableNotification: 'true' });
export const downloadAnexoAnaliseRiscoPrivacidade = (id: string, nome: string) => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/anexoDemanda/DownloadAnexoAnaliseRiscoPrivacidade/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', 'downloadArquivo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivo').outerHTML = '';
    }),
  );
};

export const downloadAnexoFormularioReqCompra = (id: string, nome: string) => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/anexoDemanda/DownloadAnexoFormularioReqCompra/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', 'downloadArquivo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivo').outerHTML = '';
    }),
  );
};

export const substituirAnexo = (values: any) => {
  const form = new FormData();
  form.append('id', values.id);
  form.append('arquivo', values.arquivo);
  form.append('justificativa', values.justificativa);
  return api.put('demandas/SubstituirArquivo', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const reabrirRequisicaoCompra = (id: string) => api.put(`demandas/reabrirRequisicaoCompra/${id}`);

export const getAnexosPecaOrcamentaria = (demandaId: string) =>
  api.get<AnexoDemanda[]>(`anexoDemanda/PecaOrcamentaria?demandaId=${demandaId}`);

export const downloadAnexoDemandaPecaOrcamentaria = (id: string, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/anexoDemanda/PecaOrcamentaria/${id}/download`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      clickDownloadElement(
        [resp.data],
        nomeDoArquivo,
        'downloadPecaOrcamentaria'
      );
    }),
  );
};

export const deleteAnexoPecaOrcamentaria = (anexoId: string) =>
  api.delete<AnexoDemanda[]>(`anexoDemanda/PecaOrcamentaria/${anexoId}`);

export const obterComentariosPecaOrcamentaria = (demandaId: string) =>
  api.get(`demandas/${demandaId}/pecaorcamentaria/comentarios`);

export const enviarComentariosPecaOrcamentaria = (demandaId: string, form: any) =>
  api.post(`demandas/${demandaId}/pecaorcamentaria/comentarios`, form);

export const solicitarEsclarecimentoDemandaAnalise = (demandaId: string) =>
  api.post(`demandas/${demandaId}/solicitarEsclarecimentoDemandaAnalise`);

export interface IGetDemandasPorStatusHistorico {
  listStatusDemandaId?: string[];
  listCodigoStatusDemanda?: number[];
  listQuery?: string[];
  demandaId?: string;
  usuarioId?: string;
}

export const getDemandasPorStatusHistorico = (values: IGetDemandasPorStatusHistorico) =>
  api.post<DemandaComRequisicao[]>(`demandas/historico`, values, { disableNotification: true });

export const getAllCaracteristicaContratacao = () =>
  api.get<any[]>(`caracteristicaContratacao`);

export const caracteristicaContratacaoOptions = async () => {
  var resp = await getAllCaracteristicaContratacao();
  if (resp) {
    var options = resp.map((item: any) => {
      return {
        text: item.descricao,
        value: item.value
      };
    });
    return options;
  } else {
    return [];
  }
};

export const validarModificacaoDemanda = (demandaId: string) => api.get(`demandas/${demandaId}/validarModificacaoDemanda`);
